import React, { Component } from 'react';
import '../../node_modules/bootstrap/dist/css/bootstrap-grid.css';
import '../../node_modules/bootstrap/dist/css/bootstrap.css';
import './App.css';
import SearchForm from '../containers/SearchForm';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import PricingRequestForm from '../containers/PricingRequestForm';
import RequestSentForm from '../containers/RequestSentForm';
import { Translate, withLocalize } from 'react-localize-redux';
import { renderToStaticMarkup } from 'react-dom/server';
import globalTranslations from './../translations/global.json';
import { connect } from 'react-redux';
import ReactResizeDetector from 'react-resize-detector';
import { Alert } from 'antd';
import { getLanguage } from '../utils/languages';

class App extends Component {
  constructor(props) {
    super(props);

    // basic setup, supporting only two languages for now!
    const languages = ['en', 'de'];

    var defaultLanguage = getLanguage(this.props.locale);

    this.props.initialize({
      languages,
      translation: globalTranslations,
      options: { renderToStaticMarkup, defaultLanguage: defaultLanguage }
    });

    this.resizeFrameToFit = this.resizeFrameToFit.bind(this);
  }

  resizeFrameToFit() {
    if ('parentIFrame' in window) {
      var scrollHeight = document.getElementById('root').scrollHeight;
      console.log('Resizing to ' + scrollHeight);
      window.parentIFrame.size(scrollHeight);
    }
  }

  render() {
    return (
      <Router>
        <div className="rootContainer">
          <ReactResizeDetector
            handleWidth
            handleHeight
            onResize={this.resizeFrameToFit}
          />
          {this.props.hasError && (
            <Alert
              style={{ margin: 30 }}
              message={<Translate id="Errors_Header" />}
              description={<Translate id={this.props.lastError} />}
              type="error"
              closable
            />
          )}
          <Switch>
            <Route exact path="/" component={SearchForm} />
            <Route
              exact
              path="/pricingRequest"
              component={PricingRequestForm}
            />
            <Route exact path="/requestSent" component={RequestSentForm} />

            <Route
              render={function() {
                return <p>Not Found</p>;
              }}
            />
          </Switch>

          <div hidden>
            (Source-Version: {process.env.REACT_APP_BUILD_VERSION} ({
              process.env.REACT_APP_BUILD_BRANCH
            }) - Build-Nr: {process.env.REACT_APP_BUILD_NR} / Image-Nr:{' '}
            {process.env.REACT_APP_BUILD_IMAGE_NR})
          </div>
        </div>
      </Router>
    );
  }
}

function mapStateToProps({ shopParameters, errors }) {
  return {
    locale: shopParameters.data.locale,
    hasError: errors.hasError,
    lastError: errors.error
  };
}

export default connect(mapStateToProps)(withLocalize(App));



// WEBPACK FOOTER //
// ./src/components/App.js